// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"DetailView_dataTable__1o45H"};